<template>
  <div
    :class="[$style.container, { [$style.catalog]: $route.name === 'events' }]"
  >
    <div :class="[$style.date, { [$style.error]: errors && errors.date }]">
      <p>Дата</p>
      <div :class="[$style.from]" class="from">
        <div :class="[$style.dateValue, { [$style.active]: date_after }]">
          <img src="/icons/picker.svg" alt="" />
          <p v-if="$route.name === 'events'">
            {{
              date_after
                ? date_after.substr(0, 10).split("-").reverse().join(".")
                : "__.__.____"
            }}
          </p>
          <p v-else>{{ date_after ? date_after : "__.__.____ __:__" }}</p>
          <img
            @click.stop="resetDate('date_after')"
            src="/icons/cross.svg"
            alt=""
          />
        </div>

        <VueCtkDateTimePicker
          id="from"
          ref="from"
          v-model="date_after"
          locale="ru"
          minute-interval="1"
          :no-button-now="true"
          format="YYYY-MM-DD HH:mm"
          :onlyDate="$route.name === 'events' ? true : false"
          inputSize="lg"
          color="#34c759"
          @is-shown="openPicker"
          :min-date="$route.name === 'events' ? null : formatData"
        />
      </div>
    </div>
    <div
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.counterparty },
      ]"
    >
      <p>Заказчик</p>
      <div :class="$style.select">
        <input
          v-model="counterparty"
          @input="getCounterparties"
          type="text"
          placeholder="Введите заказчика"
        />
        <img
          v-if="counterparty"
          @click.stop="select('counterparty', null), (counterparty = '')"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="counterparties.length" :class="$style.options">
        <div
          v-for="i in counterparties"
          :key="i.slug"
          @click="
            select('counterparty', { slug: i.id }),
              (counterparty = i.name),
              $store.commit('setCounterparties', [])
          "
        >
          {{ i.name }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isStatusesOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.status }]"
    >
      <p>Статус</p>
      <div @mouseover="isStatusesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.status }">{{
          selectedValues.status
            ? selectedValues.status
            : forCreation
            ? "Выберите статус"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.status"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('status', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isStatusesOpen" :class="$style.options">
        <div v-for="i in statuses" :key="i.slug" @click="select('status', i)">
          <div :class="[$style.dot, $style[i.color]]"></div>
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isTypesOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.event_type }]"
    >
      <p>Вид</p>
      <div @mouseover="isTypesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.event_type }">{{
          selectedValues.event_type
            ? selectedValues.event_type
            : forCreation
            ? "Выберите тип"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.event_type"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('event_type', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isTypesOpen" :class="$style.options">
        <div v-for="i in types" :key="i.slug" @click="select('event_type', i)">
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      v-if="$route.name === 'events'"
      @mouseleave="isCitiesOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.city }]"
    >
      <p>Город</p>
      <div @mouseover="isCitiesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.city }">
          {{
            selectedValues.city
              ? selectedValues.city
              : forCreation
              ? "Выберите город"
              : "Все"
          }}</span
        >
        <img v-if="!selectedValues.city" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-else
          @click.stop="select('city', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isCitiesOpen" :class="$style.options">
        <div
          v-for="i in cities"
          :key="i"
          @click="select('city', { slug: i, title: i })"
        >
          {{ i }}
        </div>
      </div>
    </div>
    <div
      v-if="$route.name === 'events'"
      @mouseleave="isRegionsOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.region }]"
    >
      <p>Регион</p>
      <div @mouseover="isRegionsOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.region }">{{
          selectedValues.region
            ? selectedValues.region
            : forCreation
            ? "Выберите регион"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.region"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('region', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isRegionsOpen" :class="$style.options">
        <div
          v-for="i in regions"
          :key="i"
          @click="select('region', { title: i, slug: i })"
        >
          {{ i }}
        </div>
      </div>
    </div>
    <div
      v-if="$route.name !== 'events'"
      :class="[$style.filter, { [$style.error]: errors && errors.purpose }]"
    >
      <p>Цель</p>
      <div :class="$style.textarea">
        <textarea v-model="purpose" type="text" placeholder="Введите цель" />
        <img
          v-if="purpose"
          @click.stop="select('purpose', null), (purpose = '')"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      v-if="$route.name !== 'events'"
      :class="[$style.filter, { [$style.error]: errors && errors.event }]"
    >
      <p>Событие</p>
      <div :class="[$style.textarea]">
        <textarea
          v-model="event_text"
          type="text"
          placeholder="Введите событие"
        />
        <img
          v-if="event_text"
          @click.stop="select('event', null), (event_text = '')"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      @mouseleave="isManagersOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.responsible_manager },
      ]"
    >
      <p>Ответственный</p>
      <div @mouseover="isManagersOpen = true" :class="$style.select">
        <span
          :class="{ [$style.selected]: selectedValues.responsible_manager }"
          >{{
            selectedValues.responsible_manager
              ? selectedValues.responsible_manager
              : forCreation
              ? "Выберите ответственного"
              : "Все"
          }}</span
        >
        <img
          v-if="!selectedValues.responsible_manager"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('responsible_manager', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isManagersOpen" :class="$style.options">
        <div
          v-for="i in managers"
          :key="i.username"
          @click="
            select('responsible_manager', {
              title: i.name || i.username,
              slug: $route.name === 'events' ? i.username : i.id,
            })
          "
        >
          {{ i.name || i.username }}
        </div>
      </div>
    </div>
    <div v-if="!forCreation" @click="reset" :class="$style.reset">Сбросить</div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import FILTERS from "@/assets/constants/filters.json";
import debounce from "debounce";
export default {
  data() {
    return {
      types: FILTERS.events,
      statuses: FILTERS.event_statuses,
      isTypesOpen: false,
      isStatusesOpen: false,
      isCitiesOpen: false,
      isRegionsOpen: false,
      isManagersOpen: false,
      selectedValues: {
        event_type: "",
        status: "",
        city: "",
        region: "",
        responsible_manager: "",
      },
      filters: {
        date_after: "",
        event_type: "",
        status: "",
        city: "",
        region: "",
        responsible_manager: "",
        counterparty: "",
      },
      date_after: "",
      isLoad: false,
      errors: [],
      interval: "",
      counterparty: "",
      purpose: "",
      event_text: "",
      formatData: "",
    };
  },
  components: {
    VueCtkDateTimePicker,
  },
  props: {
    forCreation: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    this.interval = setInterval(() => {
      this.filters.isNotLoad = true;
      this.$store.dispatch("getEvents", this.filters);
      this.filters.isNotLoad = false;
    }, 30000);
    if (this.$route.name !== "events") {
      await this.$store.dispatch("getManagers");
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    getCounterparties: debounce(async function () {
      await this.$store.dispatch("getCounterparties", {
        name: this.counterparty,
      });
    }, 300),
    select(field, value) {
      if (value) {
        this.selectedValues[field] = value.title;
        this.filters[field] = value.slug;
        this.$store.commit("setEventsField", { field, value: value.slug });
      } else {
        this.selectedValues[field] = "";
        this.filters[field] = "";
        this.$store.commit("setEventsField", { field, value: "" });
      }
      if (this.$route.name === "events") {
        this.getData();
      }
    },
    reset() {
      for (let key in this.selectedValues) {
        this.selectedValues[key] = "";
      }
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.date_after = "";
      this.getData();
    },
    resetDate(key) {
      this.filters[key] = "";
      if (key === "date_after") {
        this.date_after = "";
      }
      this.getData();
    },
    async getData() {
      this.$store.dispatch("getEvents", this.filters);
    },
    openPicker() {
      function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
      }

      function formatDate(date) {
        return (
          [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
          ].join("-") +
          " " +
          [padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes())].join(
            ":"
          )
        );
      }

      this.formatData = formatDate(new Date());
    },
  },
  computed: {
    counterparties() {
      return this.$store.state.counterparties.counterparties;
    },
    event() {
      return this.$store.state.events.event;
    },
    cities() {
      return this.$store.state.events.cities;
    },
    regions() {
      return this.$store.state.events.regions;
    },
    managers() {
      return this.$store.state.events.managers;
    },
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
  watch: {
    date_after() {
      if (this.$route.name === "events") {
        this.date_after
          ? (this.filters.date_after = this.date_after.substr(0, 10))
          : (this.date_after = null);
      } else {
        this.date_after
          ? (this.filters.date_after = this.date_after)
          : (this.date_after = null);
      }

      if (this.$route.name === "events") {
        this.getData();
      } else {
        if (this.$route.name === "events") {
          this.$store.commit("setEventsField", {
            field: "date",
            value: this.date_after.substr(0, 10),
          });
        } else {
          this.$store.commit("setEventsField", {
            field: "date",
            value: this.date_after,
          });
        }
      }
    },
    purpose() {
      this.$store.commit("setEventsField", {
        field: "purpose",
        value: this.purpose,
      });
    },
    event_text() {
      this.$store.commit("setEventsField", {
        field: "event",
        value: this.event_text,
      });
    },

    event() {
      if (!this.isLoad) {
        if (this.event.id) {
          this.selectedValues = {
            event_type: this.event.event_type
              ? this.types.find((i) => i.slug === this.event.event_type).title
              : "",
            status: this.statuses.find((i) => i.slug === this.event.status)
              .title,
          };
          this.date_after =
            this.event.date.substr(0, 10) + " " + this.event.date.substr(11, 5);
          this.counterparty = this.event.counterparty.name;
          this.event_text = this.event.event;
          this.purpose = this.event.purpose;
          this.selectedValues.responsible_manager =
            this.event.responsible_manager.name ||
            this.event.responsible_manager.username;
        }
        this.isLoad = true;
      }
    },
    allErrors() {
      this.errors = this.allErrors;
    },

    async isManagersOpen() {
      if (
        this.isManagersOpen &&
        (!this.managers || this.managers.length === 0)
      ) {
        await this.$store.dispatch("getManagers");
      }
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  &.catalog {
    align-items: flex-end;
  }
  > div {
    width: 100%;
    p {
      @include Body3;
      color: $t-secondary;
      margin: 0 0 0.25rem 0;
    }
  }
  .date {
    .from,
    .before {
      position: relative;
      .dateValue {
        height: 2.5rem;
        @include Subtitle;
        color: $t-secondary;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid $bg-separator;
        gap: 0.5rem;
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        cursor: pointer;
        p {
          flex: 1 1 auto;
          position: relative;
          top: 0.2rem;
        }
        img {
          position: relative;
          z-index: 2;
        }
        &.active {
          p {
            color: $t-primary;
            @include Subtitle;
          }
        }
      }

      input {
        opacity: 0;
      }
      label {
        display: none;
      }
    }
    &.error {
      p {
        color: $red;
      }
      .from {
        .dateValue {
          border: 1px solid $red;
        }
      }
    }
  }
  .filter {
    position: relative;
    .select {
      padding: 0.75rem;
      @include Subtitle;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      cursor: pointer;
      span.selected {
        color: $t-primary;
      }
      input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: none;
        background-color: inherit;
        @include Subtitle;
        &::placeholder {
          @include Subtitle;
        }
      }
    }
    .textarea {
      @include Subtitle;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      position: relative;
      img {
        position: absolute;
        top: 0.75rem;
        right: 0.5rem;
        z-index: 2;
        cursor: pointer;
      }
      span.selected {
        color: $t-primary;
      }
      textarea {
        padding: 0.75rem 1.25rem 0 0.75rem;
        width: 100%;
        height: 10rem;
        min-height: 2.55rem;
        outline: 0;
        border: none;
        background-color: inherit;
        resize: vertical;
        @include scrollbarY;
        @include Subtitle;
        &::placeholder {
          @include Subtitle;
        }
      }
    }
    .options {
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      position: absolute;
      z-index: 2;
      background-color: $bg-secondary;
      border-bottom: none;
      width: 100%;
      cursor: pointer;
      > div {
        color: $t-secondary;
        @include Subtitle;
        padding: 0.5rem;
        border-bottom: 1px solid $bg-separator;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .dot {
          width: 0.5rem;
          height: 0.5rem;
          flex: 0 0 0.5rem;
          border-radius: 50%;
          &.orange {
            background-color: $orange;
          }
          &.grey {
            background-color: $t-secondary;
          }
          &.green {
            background-color: $main-green;
          }
          &.purple {
            background-color: $purple;
          }
          &.blue {
            background-color: $blue-primary;
          }
          &.red {
            background-color: $red-primary;
          }
        }
      }
    }
    &.error {
      > p {
        color: $red;
      }
      .select {
        border: 1px solid $red;
      }
      .textarea {
        border: 1px solid $red;
      }
    }
  }

  .reset {
    background-color: $main-green;
    padding: 0.75rem 0;
    @include Body2;
    border-radius: 0.25rem;
    text-align: center;
    color: $t-white;
  }
}
</style>

<style lang="scss">
.date-time-picker {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.5rem;
  width: 100%;
}
.fs-16 {
  display: none;
}
.custom-button {
  display: none;
}
.datepicker-button-content {
  color: $main-green !important;
}
</style>
